
$views.profilesettings = {

	display : function() {

		jQuery('#password').keyup(function () {
			$soupmail.sidetip.validatePassword();
		});

		jQuery('#password2').keyup(function () {
			$soupmail.sidetip.validatePassword2();
		});

		$models.users.getMyData(function($data) {
			if ($data.user.host == '') {
				$data.user.host = 'mail.' + $data.user.email.split('@')[1];
			}
			if ($data.user.remote_username == '') {
				$data.user.remote_username = $data.user.email;
			}
			if ($data.user.ui_remote_access_type == '') {
				$data.user.ui_remote_access_type = 'imap';
			}

			$data.user.remote_password = '';

			jQuery.each($data.user, function($key, $value) {

				$selector = '#profile-form #'+$key;
				if ($key == 'admin') { $value = ($value ? 'Administrator' : 'Regular user'); }
				if ($key == 'status') { $value = $soupmail.string.ucfirst($value); }
				if ($value === false) { $value = 'false'; }
				if ($value === true) { $value = 'true'; }

				if (($value != null) && ($value !== '')) {
					if (jQuery($selector).is('input') || jQuery($selector).is('select')) {
						jQuery($selector).val($value);
					} else {
						jQuery($selector).text($value);
					}
				}

			});

		});

	}

};



// WEBPACK FOOTER //
// ./src/js/views/desktop.profilesettings.js